import { all, fork } from 'redux-saga/effects';
import authWatcherSaga from './auth/authSaga';
import courseWatcherSaga from './course/courseSaga';
import profileWatcherSaga from './profile/profileSaga';
import questionBankSaga from './questionBank/questionBankSaga';
import { sessionWatcherSaga } from './sessionTiming/sessionTimingSaga';
import gradeWatcherSaga from './gradingModel/gradingModelSaga';
import studyWatcherSaga from './study/studySaga';
import irGradeWatcherSaga from './IRGrading/IRGradingSaga';
import studentWatcherSaga from './student/studentSaga';
import activityReportWatcherSaga from './activityReport/activityReportSaga';
import speechConfigWatcherSaga from './speechConfig/speechConfigSaga';
import teacherDashboardWatcherSaga from './teacherDashboard/teacherDashboardSaga';
import scoringWatcherSaga from './scoring/scoringSaga';

export function* rootSaga() {
    yield all([fork(authWatcherSaga)]);
    yield all([fork(courseWatcherSaga)]);
    yield all([fork(profileWatcherSaga)]);
    yield all([fork(questionBankSaga)]);
    yield all([fork(gradeWatcherSaga)]);
    yield all([fork(irGradeWatcherSaga)]);
    yield all([fork(speechConfigWatcherSaga)]);
    yield all([fork(sessionWatcherSaga)]);
    yield all([fork(studyWatcherSaga)]);
    yield all([fork(studentWatcherSaga)]);
    yield all([fork(activityReportWatcherSaga)]);
    yield all([fork(teacherDashboardWatcherSaga)]);
    yield all([fork(scoringWatcherSaga)]);
}

export default rootSaga;